import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-service-card',
  imports: [RouterLink],
  templateUrl: './service-card.component.html',
  styleUrl: './service-card.component.scss',
  host: {
    '[style.flex-direction]': 'layout()'
  }
})
export class ServiceCard {
  header = input.required<string>();
  subtitle = input.required<string>();
  layout = input<'row' | 'row-reverse'>('row');
}
